import useLocaleText from 'components/useLocaleText'

export const aiCreationLiterals = {
  title: { key: 'create_ai_vm_task_btn', fallback: { en: 'Start AI Audit' } },
  prompt: { key: 'ai_prompt_title', fallback: { en: 'AI prompt' } },
  assign: { key: 'task_sett', fallback: { en: 'Assign' } },
  preview: { key: 'preview', fallback: { en: 'Preview' } },
  next: { key: 'admin_next_button', fallback: { en: 'Next' } },
  start: { key: 'start', fallback: { en: 'Start' } },
  back: { key: 'header_button_back', fallback: { en: 'Back' } },
  close: { key: 'close', fallback: { en: 'Close' } },
  cancel: { key: 'cancel', fallback: { en: 'Cancel' } },
  remove: { key: 'delete', fallback: { en: 'Delete' } },
  publish: { key: 'publish_now', fallback: { en: 'Publish now' } },
  generate: { key: 'ai_generate_preview', fallback: { en: 'Generate preview' } },
  photo: { key: 'subtask_image', fallback: { en: 'Ask for a photo' } },
  question: { key: 't_st_open_qst', fallback: { en: 'Open question' } },
  photoHint: { key: 'ai_onboard_step2_photo', fallback: { en: 'Staff take a photo for AI to check.' } },
  questionHint: { key: 'ai_onboard_step2_qst', fallback: { en: 'Staff answer your question.' } },
  onboardingTitle: { key: 'ai_onboard_title', fallback: { en: 'Tell me what to check' } },
  onboardingHint: {
    key: 'ai_audit_choose_hint',
    fallback: { en: 'Choose what the AI should check. You can start over at any time.' },
  },
  step1: { key: 'ai_audit_choose_type', fallback: { en: 'What should the AI verify?' } },
  step2: { key: 'ai_audit_write_prompt', fallback: { en: 'Write the prompt with AI' } },
  step3: { key: 'ai_audit_assign_preview', fallback: { en: 'Assign, then preview' } },
  required: { key: 'required', fallback: { en: 'Required' } },
  helper: { key: 'prompt_generator', fallback: { en: 'Prompt generator' } },
  generating: { key: 'ai_creating', fallback: { en: 'Drafting your task…' } },
  generationDone: { key: 'ai_audit_preview_ready', fallback: { en: 'Your task preview is ready' } },
  prepared: { key: 'ai_audit_input_ready', fallback: { en: 'Prompt and task settings ready' } },
  creating: { key: 'ai_audit_generating_content', fallback: { en: 'Generating task content' } },
  review: { key: 'ai_audit_prepare_preview', fallback: { en: 'Preparing your preview' } },
  resetTitle: { key: 'ai_audit_reset_title', fallback: { en: 'Remove AI subtask?' } },
  resetHint: { key: 'ai_audit_reset_hint', fallback: { en: 'You will return to choosing what the AI should check.' } },
  resetAcknowledge: {
    key: 'ai_audit_reset_acknowledge',
    fallback: { en: 'I understand that the prompt, photos and all task settings will be cleared.' },
  },
  voice: { key: 'chat_voice_start', fallback: { en: 'Start voice input' } },
  stopInsert: { key: 'chat_voice_stop_insert', fallback: { en: 'Stop and insert' } },
  microphoneDenied: {
    key: 'chat_microphone_denied',
    fallback: { en: 'Allow microphone access in your browser settings.' },
  },
  promptRequired: {
    key: 'ai_prompt_required',
    fallback: { en: 'Describe what the AI should check before continuing.' },
  },
  briefing: { key: 'ai_report_back', fallback: { en: 'AI report back' } },
  audience: { key: 'contexts', fallback: { en: 'Assignees' } },
  startDate: { key: 't_start_date', fallback: { en: 'Start date' } },
  endDate: { key: 'create_task_end_date_title', fallback: { en: 'End date' } },
  reportBack: { key: 'ai_schedule', fallback: { en: 'Report back' } },
  hours: { key: 't_hours', fallback: { en: 'hours' } },
  questionPromptHint: {
    key: 'ai_audit_question_prompt_hint',
    fallback: { en: 'Describe what to ask your team and how AI should evaluate the answer.' },
  },
  questionPromptPlaceholder: {
    key: 'ai_audit_question_prompt_placeholder',
    fallback: {
      en: 'e.g. Ask the team to explain how they prepare the display. Check that they mention prices and stock.',
    },
  },
  minutes: { key: 't_minutes', fallback: { en: 'minutes' } },
  halfway: { key: 't_halfway', fallback: { en: 'Halfway' } },
  whenDone: { key: 't_when_done', fallback: { en: 'When done' } },
}
export const useAiCreationText = () => useLocaleText(aiCreationLiterals)
